import { Suspense, lazy, useCallback } from 'react';
import S from './card.styles';
import { CardCursoComplementarProps } from './card.types';

const CardSimplificado = lazy(
  () => import('../card-simplificado/card-simplificado.component'),
);
const CardCompleto = lazy(
  () => import('../card-completo/card-completo.component'),
);
const CardErro = lazy(() => import('./fragments/card-erro/card-erro.fragment'));

export const CardCursoComplementar: React.FC<CardCursoComplementarProps> = ({
  asyncCursoComplementar,
  modeloApresentacao,
  disabled,
  footerExtra,
  onClick,
  onRetentativa,
}) => {
  const Card = useCallback(() => {
    if (asyncCursoComplementar.erro && !asyncCursoComplementar.pendente) {
      return <CardErro onAtualizar={onRetentativa} />;
    }

    if (modeloApresentacao === 'completo') {
      return (
        <CardCompleto
          asyncCursoComplementar={asyncCursoComplementar}
          onClick={onClick}
          disabled={disabled}
          footerExtra={footerExtra}
        />
      );
    }

    return (
      <CardSimplificado
        asyncCursoComplementar={asyncCursoComplementar}
        onClick={onClick}
        disabled={disabled}
        footerExtra={footerExtra}
      />
    );
  }, [
    asyncCursoComplementar,
    disabled,
    modeloApresentacao,
    footerExtra,
    onClick,
    onRetentativa,
  ]);

  return (
    <S.CardContainer role="listitem">
      <Suspense fallback={<></>}>
        <Card />
      </Suspense>
    </S.CardContainer>
  );
};
